import { Component, Input, signal, OnInit, input, effect, ViewChild, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdsAccordionModule } from '@cds/ng-web-components/accordion';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { ActionIcons } from '@cds/ng-themes';

export interface DocumentItem {
  title: string;
  description?: string;
  points?: string[];
  guidelineText?: string;
  disclaimers?: string[];
}

@Component({
  selector: 'app-document-accordion',
  imports: [CommonModule, CdsAccordionModule, TranslateModule, CdsIconModule],
  templateUrl: './document-accordion.component.html',
  styleUrl: './document-accordion.component.scss'
})
export class DocumentAccordionComponent implements AfterViewInit {
  @ViewChild('accordion', { static: false }) accordion: any;
  @ViewChildren('accordionPanel') accordionPanels!: QueryList<any>;

  documents = input<DocumentItem[]>([]);
  translationKey = input<string>();
  closeAllPanels = input<boolean>(false); // ✅ Changed from @Input to input()
  @Input() contentClass: string = 'accordion-content';
  @Input() descriptionClass: string = 'accordion-desc';
  @Input() listClass: string = 'accordion-list';
  plusIcon = ActionIcons.button_plus_filled;
  minusIcon = ActionIcons.button_minus_outlined;

  isLoading = signal<boolean>(false);
  internalDocuments = signal<DocumentItem[]>([]);

  constructor(private translate: TranslateService) {
    effect(() => {
      const docs = this.documents();

      if (docs && docs.length > 0) {
        this.internalDocuments.set(docs);
      } else {
        this.internalDocuments.set([]);
      }
    });

    // Watch for translationKey changes
    effect(() => {
      const key = this.translationKey();

      if (key) {
        this.loadFromTranslation(key);
      }
    });

    effect(() => {
      if (this.closeAllPanels()) {
        this.closeAllAccordionPanels();
      }
    });
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {

    // Try to close panels after view init if needed
    if (this.closeAllPanels()) {
      setTimeout(() => {
        this.closeAllAccordionPanels();
      }, 300);
    }
  }


  private loadFromTranslation(key: string): void {
    this.isLoading.set(true);

    this.translate.get(key).subscribe({
      next: (docs: DocumentItem[]) => {
        this.internalDocuments.set(docs);
        this.isLoading.set(false);
      },
      error: (err) => {
        this.isLoading.set(false);
      }
    });
  }

  hasPoints(doc: DocumentItem): boolean {
    return doc.points !== undefined && doc.points.length > 0;
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackByTitle(index: number, doc: DocumentItem): string {
    return doc.title;
  }

  closeAllAccordionPanels(): void {

    // ✅ Strategy 2: Use accordion.panels QueryList
    if (this.accordion?.panels) {

      const panelsArray = this.accordion.panels.toArray?.() ||
        this.accordion.panels._results ||
        [];

      if (panelsArray.length > 0) {
        panelsArray.forEach((panel: any, index: number) => {
          try {
            panel.expanded = false;
          } catch (error) {
          }
        });
        
        return;
      }
    }

  }

}
